import { useQuery } from '@tanstack/react-query';
import shopService from '../services/salesShopItems.service';

const useCountryCodes = () => {
    const { isLoading, data } = useQuery({
        queryKey: ['countryCodes'],
        queryFn: async () => await shopService.fetchCountryCodes(),
        enabled: true
    });

    return { isLoading, data };
};

export default useCountryCodes;
